import { DataType } from '..';

const notFoundLabels = {
  emailUs: 'Email us at info@neberox.com to apply for a test account',
  waitlist: 'Join the waitlist',
};

const genericLabels = {
  contactUs: 'Contattaci',
  logout: 'Esci',
  month: 'Mese',
  na: 'N/D',
  add: '+ Aggiungi',
  terms: 'Terms',
  privacy: 'Privacy Policy',
  reports: 'Reports',
  save: 'Salva',
  and: 'e',
};

const loginLabels = {
  signIn: 'Accedi',
  detail: 'Con il tuo account Google aziendale',
  new: 'Nuovo su Syntraxis?',
};

const dashboardLabels = {
  keywords: 'Parole chiave',
  toDo: 'Da fare',
  reviews: 'Reviews',
  businessLocation: 'Posizione aziendale',
};

const keywordLabels = {
  high: 'Alto',
  medium: 'Medio',
  low: 'Basso',
  delete: 'Parola Chiave Elimina',
  performanceStats: 'Statistiche di rendimento',
  typeKeyword: 'Inserisci parola chiave',
  overallStrength: 'Forza del profilo complessiva',
  reviewStats: 'Statistiche delle recensioni',
  reviewStatsInfo:
    'Riassunto di sentiment e conteggi delle recensioni per individuare rapidamente trend e aree che richiedono attenzione.',
  rankings: 'Classifiche delle parole chiave',
  description:
    "Le parole chiave per l'indicizzazione locale SEO di un luogo possono variare a seconda della posizione specifica, delle offerte e del pubblico di riferimento. Queste sono alcune delle parole chiave rilevanti per la tua attività. Tenere traccia dei progressi è fondamentale nel nostro sistema 👍",
  processingKeywords: 'Processing Keywords',
  researchKeywords:
    'The keywords for your businesses are still being researched by the simiplicty team',
  performanceStatsInfo:
    'Traccia metriche chiave di coinvolgimento nel tempo (chiamate, visite al sito, direzioni, impression) per comprendere l’impatto del marketing.',
  info: 'Monitora rendimento delle parole chiave, statistiche delle recensioni e forza complessiva del profilo. Usa questi dati per dare priorità alla SEO e misurare i progressi.',
};

const statsLabels = {
  movementInfo: '(dal primo accesso)',
  competitorsText: (count: number) => `Tra ${count} concorrenti`,
};

const reviewLabels = {
  title: 'Reply Recent Reviews',
  stars: 'Stars',
  generateReply: 'Generate Reply',
  info: 'Visualizza e gestisci le tue recensioni recenti su Google. Usa l’interruttore per mostrare solo quelle senza risposta. Clicca una recensione per aprire i dettagli, generare una risposta con IA e pubblicarla.',
};

const reportLabels = {
  searchPlaces: 'Search Places',
  typePlace: 'Type Place name',
  description: 'Generate Reply',
  addKeywords: 'Add Keywords',
  generate: 'Generate Report',
  info: 'Genera uno snapshot competitivo rapido per una sede. Fornisci luogo, raggio e parole chiave per vedere forza relativa e medie dei concorrenti.',
};

const todoLabels = {
  edit: 'Modifica elemento',
  delete: 'Elimina elemento',
  progress: 'Il progresso della tua lista di controllo',
  essentialInfo: 'Informazioni essenziali',
  mustHaves: 'Must Have di Syntraxis',
  addChecklist: 'Inserisci voce di lista di controllo',
};

const alertLabels = {
  signout: 'Are you sure you want to sign out?',
  deleteToDo: (title: DataType) => `Sei sicuro di voler eliminare "${title}"?`,
  deleteKeyword: (keyword: DataType) =>
    `Sei sicuro di voler eliminare la parola chiave "${keyword}"?`,
};

const chartLabels = {};

const settingsLabels = {
  title: 'Linee guida per rispondere alle recensioni',
  placeholder:
    'Scrivi eventuali linee guida su come formulare le risposte (tono, cose da fare/da evitare, ecc.)',
  saving: 'Salvataggio…',
  autoReplyLabel: 'Risposta automatica alle nuove recensioni',
  info: 'Definisci il tono e le regole per le risposte generate dall’IA. Abilita la risposta automatica per rispondere quando arrivano nuove recensioni (richiede automazione lato backend).',
  qrTitle: 'QR Code Recensioni Google',
  qrInfo:
    'Scansiona o stampa questo codice per collegarti direttamente alla pagina recensioni o maps della tua attività.',
  qrDownload: 'Scarica PDF',
  qrAlt: 'QR code recensioni Google',
  reviewLandingLabel: 'Messaggio pagina intermedia',
  reviewLandingPlaceholder: 'Recensisci e ottieni 20% di sconto',
  checkinsBrandingTitle: 'Branding email e offerta',
  checkinsBrandingInfo:
    "Carica il tuo logo e imposta i dettagli dell'offerta che verranno inseriti nell'email di benvenuto dopo il check-in.",
  checkinsEmailLogoLabel: 'Logo',
  checkinsEmailLogoHelp:
    "Mostrato nella parte superiore dell'email di benvenuto.",
  checkinsOfferPercentLabel: 'Offerta (% di sconto)',
  checkinsOfferPercentPlaceholder: '20',
  checkinsOfferValidityLabel: "Validità dell'offerta",
  checkinsOfferValidityPlaceholder: 'Valida per 14 giorni dopo la ricezione',
  checkinsOfferCodeLabel: 'Codice promo',
  checkinsOfferCodePlaceholder: 'BENVENUTO20',
  checkinsOfferDetailsLabel: 'Note / dettagli',
  checkinsOfferDetailsPlaceholder: 'Utilizzo singolo, solo in negozio.',
  checkinsEmailTemplateHint:
    "Questi valori vengono inseriti nel template dell'email che i clienti ricevono dopo il check-in.",
  uploadLogoCta: 'Carica logo',
  logoUploading: 'Caricamento…',
  logoPlaceholder: 'Logo',
  logoUploadFailed: 'Impossibile caricare il logo ora.',
  logoLocationRequired: 'Scegli una sede prima di caricare un logo.',
  checkinsTitle: 'Check-in QR',
  checkinsSubtitle:
    'Chi ha scansionato il tuo QR e compilato il form compare qui.',
  checkinsSearchPlaceholder: 'Cerca nome o email',
  checkinsRangeLabel: 'Intervallo',
  checkinsRange7d: 'Ultimi 7 giorni',
  checkinsRange30d: 'Ultimi 30 giorni',
  checkinsRangeAll: 'Tutto il periodo',
  checkinsOptInOnly: 'Solo opt-in',
  checkinsStatTotal: 'Check-in totali',
  checkinsStatOptIn: 'Con opt-in',
  checkinsStatRecent: 'Questa settimana',
  checkinsSelectLocation: 'Scegli una sede per vedere i check-in QR.',
  checkinsEmptyTitle: 'Ancora nessun check-in',
  checkinsEmptySubtitle:
    'Non appena i clienti scansionano e inviano il form, appariranno qui.',
  checkinsUnknownVisitor: 'Visitatore',
  checkinsOptInChip: 'Opt-in',
  checkinsNoOptInChip: 'Senza opt-in',
  checkinsSendOne: 'Invia promo',
  checkinsSendCta: 'Invia promozione',
  checkinsRefresh: 'Aggiorna',
  checkinsPromoTitle: 'Invia promozione',
  checkinsPromoBody: (count: DataType) =>
    `Questo andrà a ${count} contatti nel tuo elenco filtrato.`,
  checkinsPromoSubject: 'Oggetto',
  checkinsPromoMessage: 'Messaggio',
  checkinsPromoSend: 'Invia',
  checkinsPromoSending: 'Invio…',
  checkinsPromoCancel: 'Annulla',
  checkinsPromoSuccess: (count: DataType) =>
    `Promozione in coda per ${count} contatto/i.`,
  checkinsPromoFailed: 'Impossibile inviare la promozione ora.',
  checkinsPromoDefaultSubject: 'Offerta VIP per visitatori recenti',
  checkinsPromoDefaultMessage:
    'Grazie per essere passato! Ecco un’offerta per la tua prossima visita.',
  checkinsWelcomeTitle: 'Email di benvenuto check-in',
  checkinsWelcomeInfo:
    'Email predefinita inviata automaticamente agli ospiti che acconsentono al check-in.',
  checkinsWelcomeSubjectLabel: "Oggetto dell'email",
  checkinsWelcomeSubjectPlaceholder: 'Grazie per il check-in!',
  checkinsWelcomeMessageLabel: "Messaggio dell'email",
  checkinsWelcomeMessagePlaceholder:
    'Ciao! Grazie per aver fatto check-in. Ecco un’offerta per la tua prossima visita.',
};

const billingLabels = {
  locationsBillingTitle: 'Abbonamenti per sede',
  locationsBillingSubtitle:
    'Attiva abbonamenti per sede. I nuovi abbonamenti includono 7 giorni di prova gratuita.',
  noLocations:
    'Nessuna sede trovata. Collega il tuo account Google per visualizzare le sedi.',
  columnLocation: 'Sede',
  columnStatus: 'Stato',
  columnActions: 'Azioni',
  statusNoSubscription: 'Nessun abbonamento',
  statusTrial: 'Prova',
  statusTrialExpired: 'Prova terminata',
  statusActive: 'Attivo',
  activateWithTrial: 'Attiva abbonamento',
  billingCycleMonthly: 'Mensile',
  billingCycleYearly: 'Annuale',
  planPopular: 'Popolare',
  plans: {
    essential: {
      name: 'Essentials',
      cta: 'Inizia',
      description:
        'Piano base per proteggere la reputazione e capire come i nuovi clienti ti trovano.',
      features: [
        'Feed in tempo reale delle nuove recensioni Google',
        'Suggerimenti di risposta smart con tono coerente',
        'Insight sulle keyword che generano visite',
        'Report semplici per azioni settimanali',
      ],
      prices: {
        monthly: { display: '£29', frequency: 'Al mese' },
        yearly: { display: '£299', frequency: 'All’anno' },
      },
    },
    growth: {
      name: 'Growth',
      cta: 'Inizia',
      description:
        'Ideale per brand in crescita che vogliono gestire recensioni e social in un unico posto.',
      features: [
        'Tutto in Recensioni e Parole chiave',
        'Pianifica post sui principali canali',
        'Inbox centrale per commenti, DM e menzioni',
        'Analisi dei post su reach, clic ed engagement',
        'Suggerimenti di orari migliori in base alle performance',
      ],
      prices: {
        monthly: { display: '£59', frequency: 'Al mese' },
        yearly: { display: '£599', frequency: 'All’anno' },
      },
    },
    elite: {
      name: 'Elite',
      cta: 'Inizia',
      description:
        'Tutto il necessario per reputazione, social e automazione su più sedi.',
      features: [
        'Tutto in Growth',
        'Workflow IA automatizzati per campagne e follow-up',
        'Dashboard executive in tempo reale per sede',
        'Permessi per ruolo, audit trail e opzioni SSO',
        'Onboarding dedicato e supporto strategico',
      ],
      prices: {
        monthly: { display: '£149', frequency: 'Al mese' },
        yearly: { display: '£1,499', frequency: 'All’anno' },
      },
    },
  },
};

const reviewLandingLabels = {
  fallbackMessage: 'Recensisci e ottieni 20% di sconto',
  headingInfo: 'Ti indirizzeremo a Google Reviews dopo un breve controllo.',
  fieldName: 'Nome',
  fieldEmail: 'Email',
  optIn: 'Inviami il link alla recensione e aggiornamenti occasionali.',
  continue: 'Continua a Google Reviews',
  termsPrefix: 'Continuando accetti i nostri',
  missingUrl: 'URL delle recensioni mancante.',
  poweredBy: 'Offerto da',
};

const campaignLabels = {
  title: 'Agente Post Social',
  platform: 'Piattaforma',
  platformPlaceholder: 'Seleziona piattaforma',
  sourceMode: 'Sorgente Input',
  modeUrl: 'URL',
  modeText: 'Testo Libero',
  sourceUrl: 'URL Sorgente',
  freeText: 'Idee / Bozza Post',
  hashtagsLimit: 'Limite Hashtag',
  guidelines: 'Linee Guida Brand',
  desiredTone: 'Tono Desiderato',
  toneFriendly: 'Amichevole',
  toneProfessional: 'Professionale',
  toneWitty: 'Spiritoso',
  toneFormal: 'Formale',
  allowEmoji: 'Permetti Emoji',
  mediaOption: 'Fonte Media',
  mediaNone: 'Nessuno',
  mediaAi: 'Generato IA',
  mediaUpload: 'Carica',
  mediaUrl: 'Da URL',
  imageUrl: 'URL Immagine / Video',
  uploadFile: 'Carica File',
  approxChars: 'Conteggio Caratteri Approssimativo',
  history: 'Storico',
  output: 'Output',
  schedule: 'Programmazione',
  run: 'Esegui',
  info: 'Configura ed esegui un agente per generare post social. Fornisci una sorgente, immagine opzionale e lunghezza obiettivo. Rivedi output, storico e programmazione.',
  historyEmpty:
    'Ogni volta che clicchi esegui apparirà un elemento nello storico ordinato per data di creazione.',
  outputPlaceholder: 'L’output del post generato apparirà qui.',
  schedulePlaceholder: 'Configura generazioni ricorrenti (prossimamente).',
  tabsAria: 'Schede campagne',
  aboutAria: 'Informazioni campagne',
  ideasPlaceholder: 'Scrivi idee o incolla testo...',
  guidelinesPlaceholder:
    'Saranno applicati i valori predefiniti da Impostazioni',
  uploadButton: 'Carica File',
  generatePost: 'Genera Post',
  generating: 'Generazione…',
};

const assistantLabels = {
  promptTitle: 'Prova un prompt',
  exampleTitle: 'Esempio live',
  exampleBody:
    'Buongiorno! Situazione: i ricavi combinati Toast + Square sono saliti del 7% rispetto alla scorsa settimana, ma la Sede B ha perso il 12% dopo le 18:00. Il rating Google è sceso a 4,1 per due recensioni senza risposta. Vuoi che prepari le risposte e programmi una storia IG per recuperare il traffico serale?',
  disclaimerPrefix:
    'Syntraxis può sbagliare. Verifica le info importanti. Consulta i nostri',
  termsLink: 'Termini',
  thinking: 'Sto pensando…',
  errorMessage: "Impossibile contattare l'assistente in questo momento.",
  dataTitle: 'Risultati strutturati',
  prompts: [
    {
      text: 'Riassumi vendite e affluenza di ieri tra Toast e Square',
      category: 'insights',
    },
    {
      text: 'Scrivi una promo weekend per Instagram + email con il nostro tono',
      category: 'marketing',
    },
    {
      text: 'Segnala sedi con rating Google in calo e proponi risposte',
      category: 'reviews',
    },
    {
      text: 'Trova SKU in calo e suggerisci bundle per recuperarli',
      category: 'inventory',
    },
    {
      text: 'Evidenzia le sedi top e perché hanno superato la media',
      category: 'insights',
    },
    {
      text: 'Crea un SMS di follow-up in un clic per i clienti top di ieri',
      category: 'marketing',
    },
    {
      text: 'Individua rimborsi o annullamenti anomali nelle ultime 24 ore',
      category: 'risk',
    },
    {
      text: 'Prepara risposte a recensioni 1 stella usando le nostre linee guida',
      category: 'reviews',
    },
    {
      text: 'Costruisci un briefing giornaliero per il GM con KPI e alert',
      category: 'ops',
    },
    {
      text: 'Prepara un post per Facebook + IG coerente con il nostro tono',
      category: 'marketing',
    },
  ],
};
const expenseLabels = {
  title: 'Registro spese',
  addExpenseTitle: 'Aggiungi una spesa',
  recentExpensesTitle: 'Spese recenti',
  recentExpensesHelper:
    'Elimina in linea per rimuovere. Altri filtri in arrivo.',
  formDescriptionLabel: 'Descrizione',
  formDescriptionPlaceholder:
    'es., Chicchi di caffè, annunci Meta, pasto staff',
  formCategoryLabel: 'Categoria',
  formAmountLabel: 'Importo',
  formPaymentLabel: 'Pagamento',
  formAddButton: 'Aggiungi',
  listEmpty: 'Ancora nessuna spesa. Aggiungi la prima per monitorare i costi.',
  paymentFallback: 'Pagamento',
  totalSpend: 'Spesa totale',
  totalSpendDescription: 'Somma di tutte le spese registrate',
  byCategory: 'Per categoria',
  byCategoryPlaceholder: 'Aggiungi spese per vedere i totali per categoria.',
  aiOverline: 'Syntraxis AI Control Hub',
  aiHeadline: "Scansiona ricevute e lascia che l'IA ordini le spese",
  aiDescription:
    'Scatta una foto della ricevuta e creeremo la spesa con categoria, importo e promemoria con data. Perfetto per operazioni, scorte e rimborsi del team.',
  chipReadReceipts: 'Leggi ricevute',
  chipPosMatching: 'Abbinamento POS + carta',
  chipRouteBudgets: 'Instrada ai budget',
  chipAuditExport: 'Export pronto per audit',
  captureButton: 'Acquisisci o carica ricevuta',
  reconcileButton: "Chiedi all'IA di conciliare",
  receiptFallbackName: 'Ricevuta',
  receiptMemo: (vendor: DataType) => `${vendor} (ricevuta)`,
  receiptToast: (detail: DataType) => `Aggiunto ${detail} dalla ricevuta.`,
  categories: {
    Ops: 'Operazioni',
    Marketing: 'Marketing',
    Staff: 'Personale',
    Inventory: 'Inventario',
    Other: 'Altro',
  },
};

const italianTranslations = {
  chartLabels,
  reviewLabels,
  notFoundLabels,
  reportLabels,
  alertLabels,
  statsLabels,
  genericLabels,
  loginLabels,
  dashboardLabels,
  keywordLabels,
  todoLabels,
  settingsLabels,
  campaignLabels,
  reviewLandingLabels,
  billingLabels,
  expenseLabels,
  assistantLabels,
};

export default italianTranslations;
